export enum DatiqMenuType {
    Icon = 'Icon',
    Button = 'Button',
}
